import React from "react";

import KogModalFadeComponent from "@/main/components/modal/ModalFadeComponent";
import SecondaryButton from "@/main/components/shared/button/secondaryButton";
import { useNavigate } from "react-router-dom";
import { RoutesConstants } from "@/main/routes/routesConstants";
import { getTranslateByKey } from "@/main/services/utils";

import * as S from "./styles";

interface IModalDontAccessPrequoteProps {
	isOpenModal: boolean;
	setIsOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
	closeModal: () => void;
}

function ModalDontAccessPreQuote(_props: IModalDontAccessPrequoteProps) {
	const navigate = useNavigate();

	return (
		<S.BoxModal>
			<S.TitleModal>{getTranslateByKey("information.dontHaveAccessPrequote")}</S.TitleModal>

			<SecondaryButton onClick={() => navigate(RoutesConstants.orderSearchOrder)}>
				{getTranslateByKey("information.back")}
			</SecondaryButton>
		</S.BoxModal>
	);
}

function WrapperModalDontAccessPreQuote(props: IModalDontAccessPrequoteProps) {
	return (
		<KogModalFadeComponent open={props.isOpenModal} closeByOverlay={false} setOpen={props.setIsOpenModal}>
			<ModalDontAccessPreQuote {...props} />
		</KogModalFadeComponent>
	);
}

export default WrapperModalDontAccessPreQuote;
